import React from "react";
import styles from "./index.module.css";
import TopNavigation from "../layout/components/TopNavigation";
import barcodeScanner from "../layout/assets/barcode_scanner.png";
import pc from "../layout/assets/pc.png";
import monitor from "../layout/assets/monitor.png";
import receiptPrinter from "../layout/assets/receipt_printer.png";
import cashDrawer from "../layout/assets/cash_drawer.png";
import mouse from "../layout/assets/mouse.png";
import keyboard from "../layout/assets/keyboard.png";
import barcodeStickerPrinter from "../layout/assets/barcoder_sticker_printer.png";

const Hardware = () => {
  return (
    <div className={styles.page}>
      <TopNavigation />
      <div className={styles.catalogContainer}>
        <div className={styles.posFeaturesDiv}>HARDWARE CATALOG</div>
        <div className={styles.everyFeaturesDiv}>
          COMPLETE YOUR POS SETUP
        </div>

        <div className={styles.productsGrid}>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={barcodeScanner}
                alt="Barcode Scanner"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>Desktop Barcode Scanner</h3>
              <ul className={styles.productSpecs}>
                <li>Fast omnidirectional scanning of 1D & 2D barcodes</li>
                <li>Plug-and-play USB with optional Bluetooth</li>
                <li>Lightweight, ergonomic, and durable design</li>
                <li>Supports QR Code, Data Matrix, PDF417, and more</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={pc}
                alt="PC"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>System Unit</h3>
              <ul className={styles.productSpecs}>
                <li>Intel Core i5 processor</li>
                <li>8GB DDR4 RAM</li>
                <li>120GB SSD storage</li>
                <li>Integrated graphics</li>
                <li>Multiple USB ports for barcode scanners and receipt printers</li>
                <li>HDMI, Ethernet connectivity</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={monitor}
                alt="Monitor"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>20" LED Monitor</h3>
              <ul className={styles.productSpecs}>
                <li>20" LED display</li>
                <li>HD / HD+ resolution</li>
                <li>Slim, energy-efficient design</li>
                <li>Adjustable tilt stand</li>
                <li>HDMI and VGA inputs</li>
                <li>Wide viewing angles</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={receiptPrinter}
                alt="Receipt Printer"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>Thermal Receipt Printer</h3>
              <ul className={styles.productSpecs}>
                <li>80mm thermal receipt printer</li>
                <li>High-speed printing up to 300mm/sec</li>
                <li>203 dpi print resolution</li>
                <li>Auto-cutter included</li>
                <li>Easy drop-in paper loading</li>
                <li>USB / Ethernet connectivity options</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={cashDrawer}
                alt="Cash Drawer"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>Cash Drawer</h3>
              <ul className={styles.productSpecs}>
                <li>Heavy-duty metal cash drawer</li>
                <li>5 note / 5 coin compartments</li>
                <li>Adjustable coin trays</li>
                <li>Smooth roller mechanism</li>
                <li>Key lock with manual and electronic release</li>
                <li>RJ11 / RJ12 interface for receipt printer connection</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={mouse}
                alt="Mouse"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>USB Optical Mouse</h3>
              <ul className={styles.productSpecs}>
                <li>USB wired optical mouse</li>
                <li>High-precision optical tracking</li>
                <li>Ergonomic, ambidextrous design</li>
                <li>Plug-and-play connectivity</li>
                <li>Durable buttons with smooth scroll wheel</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={keyboard}
                alt="Keyboard"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>Keyboard</h3>
              <ul className={styles.productSpecs}>
                <li>Wired USB keyboard</li>
                <li>Full-size layout with numeric keypad</li>
                <li>Durable, spill-resistant design</li>
                <li>Comfortable typing experience</li>
                <li>Plug-and-play connectivity</li>
              </ul>
            </div>
          </div>
          <div className={styles.productCard}>
            <div className={styles.imageContainer}>
              <img
                src={barcodeStickerPrinter}
                alt="Barcode Sticker Printer"
                className={styles.productImage}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>Barcode Sticker Printer</h3>
              <ul className={styles.productSpecs}>
                <li>High-speed barcode sticker printer</li>
                <li>Prints 1D and 2D barcodes</li>
                <li>Thermal printing technology</li>
                <li>USB / Ethernet connectivity</li>
                <li>Compact and reliable for retail and inventory use</li>
              </ul>
            </div>
          </div>
        </div>
        <a
          className={styles.quotationLink}
          href="https://web.whatsapp.com/send?phone=94741041212&text=Hello%2C%20I%20would%20like%20to%20get%20a%20quotation%20for%20your%20POS%20hardware.%20Could%20you%20please%20assist%20me%3F"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.getQuotationBtn}>Get Quotation</div>
        </a>
      </div>
    </div>
  );
};

export default Hardware;
